import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { History } from 'history'

import i18nReducer from './i18n/i18n.slice'
import eventReducer from './event/event.slice'

const createRootReducer = (history: History) => combineReducers({
	router: connectRouter(history),
	i18n: i18nReducer || (() => null),
	event: eventReducer || (() => null)
})

export default createRootReducer
